import { httpRequest } from "../../http";
import { FontVariant } from "../../../models/brand.model";

export class CommandUploadFont {
    async run(file: File): Promise<FontVariant> {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/fonts/`;
        const formData = new FormData();
        formData.append("file", file);

        const response = await httpRequest<FontVariant>(url, { method: "POST", body: formData });
        return response;
    }
}
